(ns manage.campaign-page.view
  (:require [cljs-bean.core :refer [->clj]]
            [common.patterns.stats-daterange-select :refer [recent-stats-daterange]]
            [common.queries :refer [use-mutation use-queries]]
            [common.resource.query.campaign :as cq]
            [common.util :as util]
            [common.widgets.menu :refer [menu]]
            [common.widgets.page :as page]
            [linked.core :as l]
            [manage.adset.list-view :as list-view]
            [manage.campaign-insights-page.view.core :refer [campaign-insights]]
            [manage.campaign.table.view :refer [enrich-status render-status]]
            [manage.export-tags-ocp.view]
            [re-frame.core :as rf]
            [uix.core :as uix :refer [$ defui]]
            [uix.re-frame :refer [use-subscribe]]))

(defui campaign-menu
  [{:keys [archived id] :as campaign}]
  (let [{patch-campaign :mutate} (use-mutation (cq/patch-campaign-mutation {:campaign-id id}))]
    ($ menu
       {:icon "more_vert"
        :items [{:label "Rename"
                 :on-click #(rf/dispatch [:modal/open
                                          {:id :campaign/rename
                                           :props {:campaign campaign}}])}
                {:label (if archived
                          "Unarchive"
                          "Archive")
                 :on-click (fn []
                             (if archived
                               (patch-campaign {:archived false})
                               (rf/dispatch [:modal/open
                                             {:id :confirm-archive
                                              :props {:on-confirm (fn []
                                                                    (patch-campaign
                                                                     {:archived true}
                                                                     #js {:onSuccess #(rf/dispatch [:modal/close])}))
                                                      :type "campaign"}}])))}]})))

(def tabs
  (l/map :adsets
         {:label "Adsets"
          :view list-view/list-view-contents
          :container-sx #js {:overflow "hidden"}}

         :insights
         {:label "Insights"
          :view campaign-insights}))

(defn get-campaign-recent-stats [^js data id]
  (->> data
       ->clj
       (some (fn [{:keys [campaign-id impressions]}]
               (when (= campaign-id id)
                 {:impressions-recent impressions})))))

(defn combine-queries-results [^js results]
  (let [results (->clj results)
        [{campaign :data} {recent-stats :data}] results]
    #js {:isPending (boolean (some :isPending results))
         :data (->> (cond-> campaign
                      recent-stats (merge recent-stats))
                    enrich-status)}))

(defui campaign-page []
  (let [{:keys [campaign-id]} (use-subscribe [:url-context])
        campaign-query (cq/campaign-query {:campaign-id campaign-id})
        recent-stats-query (util/spread-obj (cq/campaigns-stats-query {:campaign-id campaign-id :daterange recent-stats-daterange})
                                            #js {:select #(get-campaign-recent-stats % campaign-id)})

        {{:keys [name status] :as campaign} :data}
        (use-queries #js {:queries #js [campaign-query recent-stats-query]
                          :combine combine-queries-results})]
    ($ page/page
       ($ page/page-header
          {:title name
           :tabs tabs
           :buttons ($ campaign-menu campaign)}
          ($ render-status {:status status}))
       ($ page/active-tab
          {:tabs tabs}))))
